import { DocumentMetadata } from '@/modules/layouts/components/DocumentMetadata';
import {
  PRESCREEN_OG_DESCRIPTION,
  PRESCREEN_OG_IMAGE_PATH,
} from '@/modules/prescreen/constants';

interface PrescreenDocumentMetadataProps {
  companyName?: string;
  jobTitle?: string;
}

function formatPrescreenOgTitle({
  companyName,
  jobTitle,
}: PrescreenDocumentMetadataProps) {
  const trimmedJobTitle = jobTitle?.trim();
  const trimmedCompanyName = companyName?.trim();

  if (trimmedJobTitle && trimmedCompanyName) {
    return `Voice intro for ${trimmedJobTitle} at ${trimmedCompanyName}`;
  }

  if (trimmedJobTitle) {
    return `Voice intro for ${trimmedJobTitle}`;
  }

  return 'Voice intro';
}

function formatPrescreenOgDescription({
  companyName,
  jobTitle,
}: PrescreenDocumentMetadataProps) {
  const trimmedJobTitle = jobTitle?.trim();
  const trimmedCompanyName = companyName?.trim();

  if (trimmedJobTitle && trimmedCompanyName) {
    return `A voice intro for ${trimmedJobTitle} at ${trimmedCompanyName} — about 8 minutes, on your schedule.`;
  }

  return PRESCREEN_OG_DESCRIPTION;
}

export function PrescreenDocumentMetadata({
  companyName,
  jobTitle,
}: PrescreenDocumentMetadataProps) {
  return (
    <DocumentMetadata
      title={formatPrescreenOgTitle({ companyName, jobTitle })}
      description={formatPrescreenOgDescription({ companyName, jobTitle })}
      imagePath={PRESCREEN_OG_IMAGE_PATH}
      appendBrand={false}
    />
  );
}
